<script setup>
import { computed } from 'vue';
import { svgBanco } from '@edusites/bancos-brasil';

const props = defineProps({
  provider: { type: String, default: '' },
  bankCode: { type: [String, Number], default: '' },
});

const codeProviders = {
  '001': 'bancodobrasil',
  '012': 'inbursa',
  '033': 'santander',
  '070': 'brb',
  925: 'brb',
  '077': 'inter',
  104: 'caixa',
  121: 'agibank',
  149: 'facta',
  212: 'original',
  237: 'bradesco',
  260: 'nubank',
  290: 'pagbank',
  318: 'bmg',
  323: 'mercadopago',
  329: 'qitech',
  336: 'c6',
  341: 'itau',
  389: 'mercantil',
  626: 'c6',
  655: 'bv',
  707: 'daycoval',
  748: 'sicredi',
  756: 'sicoob',
  935: 'facta',
};
const resolvedProvider = computed(() => {
  const code = String(props.bankCode ?? '').trim();
  return code ? codeProviders[code.padStart(3, '0')] || '' : props.provider;
});
const packagedProviders = new Set([
  'asaas',
  'c6',
  'bmg',
  'neon',
  ...Object.values(codeProviders),
]);
const localLogos = {
  brb: 'brb.png',
  novo_saque: 'novo-saque.webp',
  bank321: '321bank.png',
  daycoval: 'daycoval.webp',
  inbursa: 'inbursa.png',
  qitech: 'qitech.svg',
  fintech_corban: 'fintech-corban.png',
  v8: 'v8.svg',
  soma: 'soma.png',
  bull: 'bull.svg',
  handplus: 'handplus.png',
  facta: 'facta.svg',
  presenca_bank: 'presenca.svg',
};
const localLogo = computed(() => localLogos[resolvedProvider.value]);
const logo = computed(() => {
  if (localLogo.value) return `/brand-assets/banks/${localLogo.value}`;
  if (!packagedProviders.has(resolvedProvider.value)) return null;
  const svg = svgBanco({ nome: resolvedProvider.value, tamanho: 32 });
  return svg
    ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
    : null;
});
</script>

<template>
  <span
    class="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-lg text-n-slate-11 ring-1 ring-n-weak"
    :class="[
      localLogo
        ? ['presenca_bank', 'v8', 'fintech_corban', 'qitech'].includes(
            resolvedProvider
          )
          ? 'bg-[#202024]'
          : 'bg-white'
        : 'bg-n-alpha-2',
    ]"
    aria-hidden="true"
  >
    <img
      v-if="logo"
      :src="logo"
      alt=""
      width="32"
      height="32"
      class="h-8 w-full object-contain"
      :class="localLogo && 'p-1'"
    />
    <span v-else class="i-lucide-landmark size-4" />
  </span>
</template>
